export type WishPriority = "high" | "medium" | "low";
export type WishStatus = "free" | "reserved" | "purchased";

export interface WishEvent {
  id: string;
  title: string;
  date: string;
}

export interface Wish {
  id: string;
  event_id?: string;
  event?: WishEvent;
  title: string;
  description?: string;
  url?: string;
  image_url: string | null;
  price: number | null;
  priority: WishPriority;
  status: WishStatus;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

// Owner wishlist responses intentionally omit status so reservation state
// cannot leak to the recipient through either the UI or its TypeScript model.
export type OwnerWish = Omit<Wish, "status"> & { status?: never };
export interface NonOwnerWish extends Wish {
  my_reservation_id?: string;
  can_reserve: boolean;
  can_cancel: boolean;
  can_purchase: boolean;
}
export type WishListItem = OwnerWish | NonOwnerWish;

export interface CreateWishRequest {
  title: string;
  description?: string;
  url?: string;
  image_url?: string;
  price?: number;
  priority?: WishPriority;
  event_id?: string;
}

export interface WishPreview {
  title: string | null;
  description: string | null;
  image_url: string | null;
  price: number | null;
}

export interface UpdateWishRequest {
  title?: string;
  description?: string | null;
  url?: string | null;
  priority?: WishPriority;
  event_id?: string | null;
}

export interface DeleteWishResponse {
  id: string;
  deleted: true;
}

export function isOwnerWish(wish: WishListItem): wish is OwnerWish {
  return !("status" in wish);
}

export type WishResponse = Wish;
